export var granularPrivilegesIds = [
    "SOURCE_PLATFORM",
    "GROUP_PLATFORM",
    "API_KEY_PLATFORM",
    "INDEXING_PIPELINE_EXTENSION_PLATFORM",
    "QUERY_PIPELINE_SEARCH_API",
    "PUSH_IDENTITY_PLATFORM",
    "PUSH_DOCUMENT_PLATFORM",
    "MERCHANDISING_HUB_COMMERCE"
];
/**
 * This constant seems useless, but its purpose is to have a memoized empty array to avoid unnecessary re-renders.
 */ export var noAccess = [];

//# sourceMappingURL=PrivilegesTableConstants.js.map